// Helper kecil sejenis lib/api.ts di proyek MANTRA -- sebelum ini localStorage cuma nyimpen
// `token`, role/nama tidak pernah disimpan sama sekali (login jaman dulu cuma 1 akun admin,
// tidak butuh role). Sekarang login bisa admin/teknisi, dipakai Layout.jsx/App.jsx/Pengaturan.jsx
// dkk supaya tidak ada localStorage.getItem('role') mentah bertebaran di banyak file.
export function getRole() {
  return localStorage.getItem('role') || 'admin' // fallback aman: sesi lama sebelum fitur ini
}

export function getNama() {
  return localStorage.getItem('nama') || localStorage.getItem('username') || ''
}

export function isAdmin() {
  return getRole() === 'admin'
}

export function setAuthData({ token, username, nama, role }) {
  localStorage.setItem('token', token)
  localStorage.setItem('username', username || '')
  localStorage.setItem('nama', nama || '')
  localStorage.setItem('role', role || 'admin')
}

export function clearAuthData() {
  localStorage.removeItem('token')
  localStorage.removeItem('username')
  localStorage.removeItem('nama')
  localStorage.removeItem('role')
}

// Tujuan setelah login dari query ?next= (mis. link /ambil-lokasi/:username yg dibuka teknisi yg
// belum login). Cuma path internal yg diterima -- "//evil.com" atau "https://..." ditolak supaya
// halaman login tidak bisa dipakai sbg open redirect.
export function nextAman(raw) {
  if (typeof raw !== 'string' || !raw.startsWith('/') || raw.startsWith('//') || raw.startsWith('/login')) return null
  return raw
}

// Bangun URL /login yg membawa halaman tujuan (kosong utk "/" atau halaman login itu sendiri).
export function urlLoginDenganNext(pathDanQuery) {
  const n = nextAman(pathDanQuery)
  return n && n !== '/' ? `/login?next=${encodeURIComponent(n)}` : '/login'
}
